module.exports = __webpack_public_path__ + "static/media/img2.9da345e9.jpg";